export const advancedActions = "Knc";
export const customizeActions = "Lnc";
export const emojiTooltip = "Mnc";
export const itemHeaderLike = "Nnc";
export const itemHeaderReplyByMeeting = "Onc";
export const itemHeaderDelete = "Pnc";
export const itemHeaderAddToSafeSenders = "Qnc";
export const itemHeaderMarkAsPhishing = "Rnc";
export const itemHeaderViewMessageSource = "Snc";
export const itemHeaderDownload = "Tnc";
export const itemHeaderViewMessageDetails = "Unc";
export const messageSafety = "Vnc";
export const none = "Wnc";
export const otherAddins = "Xnc";
export const otherReplyActions = "Ync";
export const proofingSettings = "Znc";
export const quickUseLabel = "_nc";
export const readUnread = "$nc";
export const replyByImSurfaceActionLabel = "aoc";
export const replyAllByImSurfaceActionLabel = "boc";
export const setDictationLanguage = "coc";
export const toggleDarkCompose = "doc";
export const toggleDictationToolTip = "eoc";
export const viewActions = "foc";
export const createFluidDocument = "goc";
export const setReaction = "hoc";
export const forwardEmailAsAttachment = "ioc";
export const findTimeTooltip = "joc";
export default {advancedActions,customizeActions,emojiTooltip,itemHeaderLike,itemHeaderReplyByMeeting,itemHeaderDelete,itemHeaderAddToSafeSenders,itemHeaderMarkAsPhishing,itemHeaderViewMessageSource,itemHeaderDownload,itemHeaderViewMessageDetails,messageSafety,none,otherAddins,otherReplyActions,proofingSettings,quickUseLabel,readUnread,replyByImSurfaceActionLabel,replyAllByImSurfaceActionLabel,setDictationLanguage,toggleDarkCompose,toggleDictationToolTip,viewActions,createFluidDocument,setReaction,forwardEmailAsAttachment,findTimeTooltip};